/**
 * @typedev PageState
 * @property {number} page
 * @property {number} pageSize
 */

/**
 * Pagination mixin for the `TableView component`.
 * See `src/views/Donations/Donations.js` for an example of it's usage
 * @param {PageState} pageState
 * @param {(PageState) => any} setPageState
 * @param {number} count
 */
export function withPagination(pageState, setPageState, count, invalidate) {
  return {
    pagination: true,
    paginationMode: 'server',
    paginationModel: {
      page: pageState.page,
      pageSize: pageState.pageSize,
    },
    onPaginationModelChange: (model) => {
      setPageState((prev) => ({
        ...prev,
        page: model.page,
        pageSize: model.pageSize,
      }));
      // Defer invalidation so effects see the updated pageState
      setTimeout(() => invalidate(), 0);
    },
    pageSizeOptions: [25, 50, 100],
    rowCount: count ?? 0,
  };
}
